/**
 * Generated by orval 🍺
 * Do not edit manually.
 * PSPulse API
 * South Tyrol Pronto Soccorso queue data — with a memory: history, trends, and forecasts. Data source: the CC0 PS_Queue feed from Open Data Südtirol (https://dati.retecivica.bz.it/). Tier-1 read endpoints (live overview, per-hospital history, day×hour heatmap, estimated wait) are live; the estimated-wait figures are deliberately rough, drain-rate estimates.
 * OpenAPI spec version: 1.0.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  EstimatedWaitResponse,
  GetHospitalHistoryParams,
  GetHospitalTrendParams,
  HospitalHeatmapResponse,
  HospitalHistoryResponse,
  HospitalTrendResponse,
  HttpValidationProblemDetails,
  LiveOverviewResponse,
  ProblemDetails
} from '../model';

import { customAxiosInstance } from '../../axios-instance.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Returns every hospital's most-recent per-triage queue reading. Hospitals with no data yet are still listed (empty triage, zero total). Backs the live view, the "which PS right now?" comparison, and the triage-mix snapshot.
 * @summary Live overview of all hospitals
 */
export const getLiveOverview = (

 options?: SecondParameter<typeof customAxiosInstance>,signal?: AbortSignal
) => {


      return customAxiosInstance<LiveOverviewResponse>(
      {url: `/hospitals`, method: 'GET', ...(signal ? { signal }: {})
    },
      options);
    }




export const getGetLiveOverviewQueryKey = () => {
    return [
    `/hospitals`
    ] as const;
    }


export const getGetLiveOverviewQueryOptions = <TData = Awaited<ReturnType<typeof getLiveOverview>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLiveOverview>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLiveOverviewQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLiveOverview>>> = ({ signal }) => getLiveOverview(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLiveOverview>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLiveOverviewQueryResult = NonNullable<Awaited<ReturnType<typeof getLiveOverview>>>
export type GetLiveOverviewQueryError = unknown


export function useGetLiveOverview<TData = Awaited<ReturnType<typeof getLiveOverview>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLiveOverview>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLiveOverview>>,
          TError,
          Awaited<ReturnType<typeof getLiveOverview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLiveOverview<TData = Awaited<ReturnType<typeof getLiveOverview>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLiveOverview>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLiveOverview>>,
          TError,
          Awaited<ReturnType<typeof getLiveOverview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLiveOverview<TData = Awaited<ReturnType<typeof getLiveOverview>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLiveOverview>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Live overview of all hospitals
 */

export function useGetLiveOverview<TData = Awaited<ReturnType<typeof getLiveOverview>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLiveOverview>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLiveOverviewQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Returns the gap-filled 5-minute queue history for one hospital over a recent window (1–48 hours, default 24), as one time series per triage level. Collector-downtime holes are carried forward; leading buckets with no prior value are null.
 * @summary Gap-filled queue history for one hospital
 */
export const getHospitalHistory = (
    slug: string,
    params?: GetHospitalHistoryParams,
 options?: SecondParameter<typeof customAxiosInstance>,signal?: AbortSignal
) => {


      return customAxiosInstance<HospitalHistoryResponse>(
      {url: `/hospitals/${slug}/history`, method: 'GET',
        params, ...(signal ? { signal }: {})
    },
      options);
    }




export const getGetHospitalHistoryQueryKey = (slug: string,
    params?: GetHospitalHistoryParams,) => {
    return [
    `/hospitals/${slug}/history`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetHospitalHistoryQueryOptions = <TData = Awaited<ReturnType<typeof getHospitalHistory>>, TError = HttpValidationProblemDetails | ProblemDetails>(slug: string,
    params?: GetHospitalHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHospitalHistory>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHospitalHistoryQueryKey(slug,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHospitalHistory>>> = ({ signal }) => getHospitalHistory(slug,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: slug !== null && slug !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHospitalHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetHospitalHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getHospitalHistory>>>
export type GetHospitalHistoryQueryError = HttpValidationProblemDetails | ProblemDetails


export function useGetHospitalHistory<TData = Awaited<ReturnType<typeof getHospitalHistory>>, TError = HttpValidationProblemDetails | ProblemDetails>(
 slug: string,
    params: undefined |  GetHospitalHistoryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHospitalHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHospitalHistory>>,
          TError,
          Awaited<ReturnType<typeof getHospitalHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHospitalHistory<TData = Awaited<ReturnType<typeof getHospitalHistory>>, TError = HttpValidationProblemDetails | ProblemDetails>(
 slug: string,
    params?: GetHospitalHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHospitalHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHospitalHistory>>,
          TError,
          Awaited<ReturnType<typeof getHospitalHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHospitalHistory<TData = Awaited<ReturnType<typeof getHospitalHistory>>, TError = HttpValidationProblemDetails | ProblemDetails>(
 slug: string,
    params?: GetHospitalHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHospitalHistory>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gap-filled queue history for one hospital
 */

export function useGetHospitalHistory<TData = Awaited<ReturnType<typeof getHospitalHistory>>, TError = HttpValidationProblemDetails | ProblemDetails>(
 slug: string,
    params?: GetHospitalHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHospitalHistory>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetHospitalHistoryQueryOptions(slug,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Returns the queue trend for one hospital over a long window (7d, 30d, 90d, or all), as one series per triage level, served from the hourly continuous aggregate. Each point carries the bucket's average plus its min/max band. 7d/30d are hourly buckets, 90d/all are daily. Unlike the 48h history, gaps are NOT carried forward — an empty bucket is null so the chart breaks the line honestly. 404 on unknown slug, 400 on an unknown window.
 * @summary Long-window queue trend for one hospital
 */
export const getHospitalTrend = (
    slug: string,
    params?: GetHospitalTrendParams,
 options?: SecondParameter<typeof customAxiosInstance>,signal?: AbortSignal
) => {


      return customAxiosInstance<HospitalTrendResponse>(
      {url: `/hospitals/${slug}/trend`, method: 'GET',
        params, ...(signal ? { signal }: {})
    },
      options);
    }




export const getGetHospitalTrendQueryKey = (slug: string,
    params?: GetHospitalTrendParams,) => {
    return [
    `/hospitals/${slug}/trend`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetHospitalTrendQueryOptions = <TData = Awaited<ReturnType<typeof getHospitalTrend>>, TError = HttpValidationProblemDetails | ProblemDetails>(slug: string,
    params?: GetHospitalTrendParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHospitalTrend>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHospitalTrendQueryKey(slug,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHospitalTrend>>> = ({ signal }) => getHospitalTrend(slug,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: slug !== null && slug !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHospitalTrend>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetHospitalTrendQueryResult = NonNullable<Awaited<ReturnType<typeof getHospitalTrend>>>
export type GetHospitalTrendQueryError = HttpValidationProblemDetails | ProblemDetails


export function useGetHospitalTrend<TData = Awaited<ReturnType<typeof getHospitalTrend>>, TError = HttpValidationProblemDetails | ProblemDetails>(
 slug: string,
    params: undefined |  GetHospitalTrendParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHospitalTrend>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHospitalTrend>>,
          TError,
          Awaited<ReturnType<typeof getHospitalTrend>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHospitalTrend<TData = Awaited<ReturnType<typeof getHospitalTrend>>, TError = HttpValidationProblemDetails | ProblemDetails>(
 slug: string,
    params?: GetHospitalTrendParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHospitalTrend>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHospitalTrend>>,
          TError,
          Awaited<ReturnType<typeof getHospitalTrend>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHospitalTrend<TData = Awaited<ReturnType<typeof getHospitalTrend>>, TError = HttpValidationProblemDetails | ProblemDetails>(
 slug: string,
    params?: GetHospitalTrendParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHospitalTrend>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Long-window queue trend for one hospital
 */

export function useGetHospitalTrend<TData = Awaited<ReturnType<typeof getHospitalTrend>>, TError = HttpValidationProblemDetails | ProblemDetails>(
 slug: string,
    params?: GetHospitalTrendParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHospitalTrend>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetHospitalTrendQueryOptions(slug,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Returns the average total queue length (across triage) for each Europe/Rome (day-of-week, hour) slot over all history — "when does this PS peak?". Only slots with data are returned (up to 7×24).
 * @summary Day-of-week × hour congestion heatmap
 */
export const getHospitalHeatmap = (
    slug: string,
 options?: SecondParameter<typeof customAxiosInstance>,signal?: AbortSignal
) => {


      return customAxiosInstance<HospitalHeatmapResponse>(
      {url: `/hospitals/${slug}/heatmap`, method: 'GET', ...(signal ? { signal }: {})
    },
      options);
    }




export const getGetHospitalHeatmapQueryKey = (slug: string,) => {
    return [
    `/hospitals/${slug}/heatmap`
    ] as const;
    }


export const getGetHospitalHeatmapQueryOptions = <TData = Awaited<ReturnType<typeof getHospitalHeatmap>>, TError = ProblemDetails>(slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHospitalHeatmap>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHospitalHeatmapQueryKey(slug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHospitalHeatmap>>> = ({ signal }) => getHospitalHeatmap(slug, requestOptions, signal);





   return  { queryKey, queryFn, enabled: slug !== null && slug !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHospitalHeatmap>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetHospitalHeatmapQueryResult = NonNullable<Awaited<ReturnType<typeof getHospitalHeatmap>>>
export type GetHospitalHeatmapQueryError = ProblemDetails


export function useGetHospitalHeatmap<TData = Awaited<ReturnType<typeof getHospitalHeatmap>>, TError = ProblemDetails>(
 slug: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHospitalHeatmap>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHospitalHeatmap>>,
          TError,
          Awaited<ReturnType<typeof getHospitalHeatmap>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHospitalHeatmap<TData = Awaited<ReturnType<typeof getHospitalHeatmap>>, TError = ProblemDetails>(
 slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHospitalHeatmap>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHospitalHeatmap>>,
          TError,
          Awaited<ReturnType<typeof getHospitalHeatmap>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHospitalHeatmap<TData = Awaited<ReturnType<typeof getHospitalHeatmap>>, TError = ProblemDetails>(
 slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHospitalHeatmap>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Day-of-week × hour congestion heatmap
 */

export function useGetHospitalHeatmap<TData = Awaited<ReturnType<typeof getHospitalHeatmap>>, TError = ProblemDetails>(
 slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHospitalHeatmap>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetHospitalHeatmapQueryOptions(slug,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Returns a ROUGH estimated wait for a walk-in at each triage level, from how fast the queue has drained recently (smoothed drain-rate model). Always present it as an estimate, not a promise: a null wait means "not estimable" (queue not draining / too little data), and each estimate carries a confidence. 404 on unknown slug.
 * @summary Rough estimated wait per triage level
 */
export const getEstimatedWait = (
    slug: string,
 options?: SecondParameter<typeof customAxiosInstance>,signal?: AbortSignal
) => {


      return customAxiosInstance<EstimatedWaitResponse>(
      {url: `/hospitals/${slug}/estimated-wait`, method: 'GET', ...(signal ? { signal }: {})
    },
      options);
    }




export const getGetEstimatedWaitQueryKey = (slug: string,) => {
    return [
    `/hospitals/${slug}/estimated-wait`
    ] as const;
    }


export const getGetEstimatedWaitQueryOptions = <TData = Awaited<ReturnType<typeof getEstimatedWait>>, TError = ProblemDetails>(slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEstimatedWait>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEstimatedWaitQueryKey(slug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEstimatedWait>>> = ({ signal }) => getEstimatedWait(slug, requestOptions, signal);





   return  { queryKey, queryFn, enabled: slug !== null && slug !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEstimatedWait>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEstimatedWaitQueryResult = NonNullable<Awaited<ReturnType<typeof getEstimatedWait>>>
export type GetEstimatedWaitQueryError = ProblemDetails


export function useGetEstimatedWait<TData = Awaited<ReturnType<typeof getEstimatedWait>>, TError = ProblemDetails>(
 slug: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEstimatedWait>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEstimatedWait>>,
          TError,
          Awaited<ReturnType<typeof getEstimatedWait>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEstimatedWait<TData = Awaited<ReturnType<typeof getEstimatedWait>>, TError = ProblemDetails>(
 slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEstimatedWait>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEstimatedWait>>,
          TError,
          Awaited<ReturnType<typeof getEstimatedWait>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEstimatedWait<TData = Awaited<ReturnType<typeof getEstimatedWait>>, TError = ProblemDetails>(
 slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEstimatedWait>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Rough estimated wait per triage level
 */

export function useGetEstimatedWait<TData = Awaited<ReturnType<typeof getEstimatedWait>>, TError = ProblemDetails>(
 slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEstimatedWait>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEstimatedWaitQueryOptions(slug,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






